export const VALID = "@validationToken/validation"
